module.exports = __webpack_public_path__ + "static/img/pro_cp.3be68ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro_cp.png
// module id = 240
// module chunks = 1